module.exports = __webpack_public_path__ + "img/113.c69f229a.jpg";